"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zodIsPhoneNumber = exports.zodDateString = void 0;
const zod_1 = require("zod");
const zodDateString = (isOptional = false) => {
    return zod_1.z.preprocess((arg) => {
        if (typeof arg == "string" || arg instanceof Date)
            return new Date(arg);
    }, isOptional ? zod_1.z.date().nullable().optional() : zod_1.z.date());
};
exports.zodDateString = zodDateString;
const zodIsPhoneNumber = (val) => {
    const pattern = new RegExp(/^[+]?(\d{1,2})?[\s.-]?\(?\d{3}\)?[\s.-]?\d{3,4}[\s.-]?\d{4}$/g);
    return pattern.test(val);
};
exports.zodIsPhoneNumber = zodIsPhoneNumber;
//# sourceMappingURL=common.js.map